let motorCore_data = [
    {
        id: 0,
        type: `여성 라이프스타일`,
        name: '모터코어 컬러블럭 패딩자켓',
        price: 239000,
        imgUrl: '/img/motorcore1.jpg',
        imgUrl2: '/img/motorcore1_detail1.jpg',
        imgUrl3: '/img/motorcore1_detail2.jpg',
        imgUrl4: '/img/motorcore1_detail3.jpg',
        imgUrl5: '/img/motorcore1_detail4.jpg',
        imgUrl6: '/img/motorcore1_detail5.jpg',
        imgUrl7: '/img/motorcore1_detail6.jpg',
        imgUrl8: '/img/motorcore1_detail7.jpg',
        imgUrl9: '/img/motorcore9.jpg',
        video: "/img/motorcore1_video.mp4",
        content: '모터코어 컨셉을 과하지 않게 담아 활용도가 높은 자켓입니다.',
        content2: '3온즈 패딩솜을 넣은 퀼팅형태로 간절기 시 보온성을 더해 줍니다.',
        content3: '여성의 실루엣에 예쁘게 맞도록 여성전용 입체 패턴을 적용하였습니다.',
        material: `겉감: 폴리에스터 60% 나일론 40% / 배색1: 폴리에스터 60% 나일론 40% / 배색2: 폴리테스터 60%. 나일론 40% / 안감: 폴리에스터 100% / 주머니감: 폴리에스터 100% / 충전재: 폴리에스터100%`,
        code: `1100FS2JKF4S01FDRD`
    },
    {
        id: 1,
        type: '여성 라이프스타일',
        name: '모터코어 컬러블럭 바람막이',
        price: 199000,
        imgUrl: '/img/motorcore2.jpg',
        imgUrl2: '/img/motorcore2_detail1.jpg',
        imgUrl3: '/img/motorcore2_detail2.jpg',
        imgUrl4: '/img/motorcore2_detail3.jpg',
        imgUrl5: '/img/motorcore2_detail4.jpg',
        imgUrl6: '/img/motorcore2_detail5.jpg',
        imgUrl7: '/img/motorcore2_detail6.jpg',
        imgUrl8: '/img/motorcore2_detail7.jpg',
        imgUrl9: '',
        video: "/img/motorcore2_video.mp4",
        content: '모터코어 컨셉을 과하지 않게 담아 활용도가 높은 여성 전용 블럭 자켓입니다.',
        content2: '여유있는 컴포트핏을 적용하여 편안한 착용감을 제공합니다.',
        content3: '살짝 광택감이 있는 소재와 모터코어 무드의 와펜으로 포인트를 주었습니다.',
        material: `겉감: 나일론 100%, 배색1: 폴리에스터 100%, 배색2: 나일론 100%, 안감: 폴리에스터 100%`,
        code: `1100FS2JKF3S01FBLK`
    },
    {
        id: 2,
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 컬러블럭 우븐팬츠',
        price: 159000,
        imgUrl: '/img/motorcore3.jpg',
        imgUrl2: '/img/motorcore3_detail1.jpg',
        imgUrl3: '/img/motorcore3_detail2.jpg',
        imgUrl4: '/img/motorcore3_detail3.jpg',
        imgUrl5: '/img/motorcore3_detail4.jpg',
        imgUrl6: '/img/motorcore3_detail5.jpg',
        imgUrl7: '/img/motorcore3_detail6.jpg',
        imgUrl8: '/img/motorcore3_detail7.jpg',
        imgUrl9: '',
        video: "/img/motorcore1_video.mp4",
        content: '모터코어 컨셉을 과하지 않게 담아 활용도가 높은 여성 전용 블럭 팬츠입니다.',
        content2: '여유있는 컴포트핏을 적용하여 편안한 착용감을 제공합니다.',
        content3: '살짝 광택감이 있는 소재와 모터코어 무드의 와펜으로 포인트를 주었습니다.',
        material: `겉감: 겉감: 나일론 100%, 배색1: 폴리에스터 100%, 배색2: 나일론 100%, 안감: 폴리에스터 100%`,
        code: `1100FS2WPF3S01FBLK`
    },
    {
        id: 3,
        type: '여성 라이프스타일',
        name: '모터코어 절개포인트 후드 바람막이',
        price: 199000,
        imgUrl: '/img/motorcore4.jpg',
        imgUrl2: '/img/motorcore4_detail1.jpg',
        imgUrl3: '/img/motorcore4_detail2.jpg',
        imgUrl4: '/img/motorcore4_detail3.jpg',
        imgUrl5: '/img/motorcore4_detail4.jpg',
        imgUrl6: '/img/motorcore4_detail5.jpg',
        imgUrl7: '/img/motorcore4_detail6.jpg',
        imgUrl8: '/img/motorcore4_detail7.jpg',
        imgUrl9: '/img/motorcore10.jpg',
        video: "/img/motorcore1_video.mp4",
        content: '고프코어 컨셉을 담아 곡선 절개로 포인트를 준 여성 전용 자켓입니다.',
        content2: '여유있는 컴포트핏을 적용하여 편안한 착용감을 제공합니다.',
        content3: `(S,M은 여성전용 L 사이즈는 남성전용 사이즈입니다.)`,
        material: `겉감: 나일론 100%, 배색1: 나일론 100%, 배색2: 나일론 100%, 배색3: 나일론 100%, 안감1: 폴리에스터 100%, 안감2: 폴리에스터 100%`,
        code: `1100FS2JKF3S03FGRY`
    },
    {
        id: 4,
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 절개포인트 우븐팬츠',
        price: 159000,
        imgUrl: '/img/motorcore5.jpg',
        imgUrl2: '/img/motorcore5_detail1.jpg',
        imgUrl3: '/img/motorcore5_detail2.jpg',
        imgUrl4: '/img/motorcore5_detail3.jpg',
        imgUrl5: '/img/motorcore5_detail4.jpg',
        imgUrl6: '/img/motorcore5_detail5.jpg',
        imgUrl7: '/img/motorcore5_detail6.jpg',
        imgUrl8: '/img/motorcore5_detail7.jpg',
        imgUrl9: '/img/motorcore11.jpg',
        video: "/img/motorcore1_video.mp4",
        content: '고프코어 컨셉을 담아 곡선 절개로 포인트를 준 여성 전용 팬츠입니다.',
        content2: '여유있는 컴포트핏을 적용하여 편안한 착용감을 제공합니다.',
        content3: `(S,M은 여성전용 L 사이즈는 남성전용 사이즈입니다.)`,
        material: `겉감: 나일론 100%, 배색1: 나일론 100%, 배색2: 나일론 100%, 배색3: 나일론 100%, 안감: 폴리에스터 100%`,
        code: `1100FS2WPF3S03FGRY`
    },
    {
        id: 5,
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 스트레치 카라 맨투맨',
        price: 89000,
        imgUrl: '/img/motorcore6.jpg',
        imgUrl2: '/img/motorcore6_detail1.jpg',
        imgUrl3: '/img/motorcore6_detail2.jpg',
        imgUrl4: '/img/motorcore6_detail3.jpg',
        imgUrl5: '/img/motorcore6_detail4.jpg',
        imgUrl6: '/img/motorcore6_detail5.jpg',
        imgUrl7: '/img/motorcore6_detail6.jpg',
        imgUrl8: '/img/motorcore6_detail7.jpg',
        imgUrl9: '/img/motorcore7.jpg',
        video: "/img/motorcore6_video.mp4",
        content: '사커 유니폼의 특징을 재해석한 유니크한 맨투맨입니다.',
        content2: '블럭코어 무드의 와펜과 그래픽으로 포인트를 주었습니다.',
        content3: '살짝 광택감이 나는 소프트한 소재와 여유로운 컴포트 핏으로 편안하면서 트렌디한 느낌으로 연출됩니다.',
        material: `겉감 : 폴리에스터 97%, 폴리우레탄 3% 배색 : 폴리에스터 98%, 폴리우레탄 2%`,
        code: `1100FS2POF3S01XSWH`
    },
    {
        id: 6,
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 스트레치 카라 맨투맨',
        price: 89000,
        imgUrl: '/img/motorcore7.jpg',
        imgUrl2: '/img/motorcore7_detail1.jpg',
        imgUrl3: '/img/motorcore7_detail2.jpg',
        imgUrl4: '/img/motorcore7_detail3.jpg',
        imgUrl5: '/img/motorcore7_detail4.jpg',
        imgUrl6: '/img/motorcore7_detail5.jpg',
        imgUrl7: '/img/motorcore7_detail6.jpg',
        imgUrl8: '/img/motorcore7_detail7.jpg',
        imgUrl9: '/img/motorcore6.jpg',
        video: "/img/motorcore7_video.mp4",
        content: '사커 유니폼의 특징을 재해석한 유니크한 맨투맨입니다.',
        content2: '블럭코어 무드의 와펜과 그래픽으로 포인트를 주었습니다.',
        content3: '살짝 광택감이 나는 소프트한 소재와 여유로운 컴포트 핏으로 편안하면서 트렌디한 느낌으로 연출됩니다.',
        material: `겉감 : 폴리에스터 97%, 폴리우레탄 3% 배색 : 폴리에스터 98%, 폴리우레탄 2%`,
        code: `1100FS2POF3S01XBLK`
    },
    {
        id: 7,
        type: '여성 컴포트핏 라이프스타일',
        name: '모터코어 포켓 우븐팬츠',
        price: 159000,
        imgUrl: '/img/motorcore8.jpg',
        imgUrl2: '/img/motorcore8_detail1.jpg',
        imgUrl3: '/img/motorcore8_detail2.jpg',
        imgUrl4: '/img/motorcore8_detail3.jpg',
        imgUrl5: '/img/motorcore8_detail4.jpg',
        imgUrl6: '/img/motorcore8_detail5.jpg',
        imgUrl7: '/img/motorcore8_detail6.jpg',
        imgUrl8: '/img/motorcore8_detail7.jpg',
        imgUrl9: '',
        video: "/img/motorcore8_video.mp4",
        content: '',
        content2: '블럭코어 컨셉을 재해석한 포켓 조거 팬츠입니다.',
        content3: '휠라의 심볼인 뱀부와펜을 넣어 포인트를 주었고, 여성 실루엣에 맞추어 여성전용 패턴을 적용하였습니다.',
        material: `겉감: 나일론100%`,
        code: `1100FS2WPF3S04FBLK`
    }
]


export default motorCore_data;